import { buildMockInstance } from "@armus/armus-dashboard";
import config from "../../config";
import mockSets from "../../mock-manifest";

export default buildMockInstance(config.mocks, mockSets);
